import { render, staticRenderFns } from "./AccessPage.vue?vue&type=template&id=b5b1db06"
import script from "./AccessPage.vue?vue&type=script&lang=js"
export * from "./AccessPage.vue?vue&type=script&lang=js"
import style0 from "./AccessPage.vue?vue&type=style&index=0&id=b5b1db06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports